import { Popover, PopoverPopup, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/utils/class-name";
import { EVENT_BLOCK_HEIGHT } from "./constants";

type PendingBlockVariant = "create" | "edit";

interface GhostEventBlockProps {
    leftPct: number;
    widthPct: number;
    variant: PendingBlockVariant;
    tooltipContent?: string;
}

export function GhostEventBlock({ leftPct, widthPct, variant, tooltipContent }: GhostEventBlockProps) {
    if (widthPct <= 0) return null;

    const blockClassName = cn(
        "absolute min-w-0 rounded-sm border-2 border-dashed animate-in fade-in duration-200",
        // hover and pointer-events are symmetric: interactive only when there's a tooltip
        tooltipContent ? "hover:brightness-105" : "pointer-events-none",
        EVENT_BLOCK_HEIGHT,
        variant === "create" && "border-primary/70 bg-primary/10",
        variant === "edit" && "border-info/70 bg-info/10",
    );
    const blockStyle = { left: `${leftPct}%`, width: `${widthPct}%` };

    if (tooltipContent) {
        return (
            <Popover>
                <PopoverTrigger
                    nativeButton={false}
                    openOnHover
                    delay={100}
                    render={
                        <div
                            className={blockClassName}
                            style={blockStyle}
                            role={"button"}
                            tabIndex={0}
                            aria-label={tooltipContent}
                        />
                    }
                />
                <PopoverPopup tooltipStyle className={"border-border"}>
                    {tooltipContent}
                </PopoverPopup>
            </Popover>
        );
    }

    return <div className={blockClassName} style={blockStyle} />;
}
